import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawLinkIcon from "./RawLinkIcon.svg.jsx";

const ListenIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawLinkIcon} {...props} />;
});

export default ListenIcon;
